import { useEffect, useState } from "react";
import QRCode from "qrcode";

type QRCodeImageProps = {
  value: string;
  label: string;
};

export function QRCodeImage({ value, label }: QRCodeImageProps) {
  const [dataUrl, setDataUrl] = useState("");

  useEffect(() => {
    let active = true;
    if (!value) {
      setDataUrl("");
      return;
    }
    QRCode.toDataURL(value, {
      errorCorrectionLevel: "M",
      margin: 1,
      width: 220,
      color: {
        dark: "#15201f",
        light: "#ffffff"
      }
    })
      .then((nextUrl) => {
        if (active) {
          setDataUrl(nextUrl);
        }
      })
      .catch(() => {
        if (active) {
          setDataUrl("");
        }
      });
    return () => {
      active = false;
    };
  }, [value]);

  if (!dataUrl) {
    return null;
  }

  return (
    <div className="qr-code">
      <img src={dataUrl} alt={label} />
    </div>
  );
}
